import React, { useEffect, useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, AppBar, Toolbar,
    IconButton, Grid, Card, CardContent, Stack,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';

import loader from '../common/loader.gif';
import request from '../../utils/request';
import { selectEndorsmentFormData, updateEndorsementScreenNumber, updateSelectedPolicyDetails } from 'src/features/rfqDataSlice';
import CustomerDetails from './sections/CustomerDetails/CustomerDetails';
import DynamicForm from './sections/DynamicForms/DynamicForm';
import SumInsured from './sections/SumInsured';
import RiskDescription from './sections/RiskDescription/RiskDescription';
import SuggestedDeductible from './sections/suggestedDeductible/SuggestedDeductible';
import CoverageRemark from './sections/CoverageRemark/CoverageRemark';
import ClausesRemark from './sections/ClausesRemark/ClausesRemark';
import HypotheticalDetails from './sections/HypotheticalDetails/HypotheticalDetails';
import WarrantiesExclusions from './sections/Warranties_exclusions/WarrantiesExclusions';
const EndorsementUpdateScreenOne = ({ editData, closeModal, setShowSnackBarAlert }) => {
    const dispatch = useDispatch();
    const [isLoading, setLoading] = useState(true);
    const [suminsuredSectionData, setSuminsuredSectionData] = useState<any[]>([]);
    const endorsementFormData = useSelector(selectEndorsmentFormData);
    const [policyDetailsData, setPolicyDetailData] = useState<any[]>([]);

    useEffect(() => {
        //  getEndorsementData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (endorsementFormData.policyId) {
            getPolicyDetailData()
        }

    }, [endorsementFormData.policyId])

    const getEndorsementData = async (filter = true) => {
        request({
            url: 'insurancePolicy/getSumInsuredSections',
            method: 'post',
            data: {
                orderColumn: 'id',
                orderDirection: 'DESC',
                offset: 0,
                limit: 5000,
                policyId: editData?.policyId

            }
        }).then(
            (response) => {
                setSuminsuredSectionData(response['data']);
                setLoading(false);
            },
            (error) => {
                console.log(error);
            }
        );
    };

    const getPolicyDetailData = () => {
        request({
            url: 'insurancePolicy/getPolicyById',
            method: 'post',
            data: {
                policyId: endorsementFormData?.policyId

            }
        }).then(
            (response) => {
                setPolicyDetailData(response['data']);
                dispatch(updateSelectedPolicyDetails(response['data']))
                setLoading(false);
            },
            (error) => {
                console.log(error);
            }
        );
    }

    const validateAndPassTwoScreenTwo = () => {
        dispatch(updateEndorsementScreenNumber(2))
    }

    return (
        <div>

            {/* Full-Screen Dialog */}
            <Dialog
                fullScreen
                open={true}
                onClose={closeModal}
            >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={closeModal}
                            aria-label="close"
                            sx={{ marginLeft: 1 }}
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography sx={{ flex: 1 }} variant="h6" component="div">
                            Policy Data
                        </Typography>

                    </Toolbar>
                </AppBar>

                <DialogContent>
                    <Grid container>
                        <Grid item xs={12}>
                            <Card sx={{ marginBottam: '10px' }}>
                                <CardContent>
                                    <div style={{ textAlign: 'right' }}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={validateAndPassTwoScreenTwo}
                                        >
                                            Proceed
                                        </Button>
                                    </div>

                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: '10px' }}>
                            <Card sx={{ marginBottam: '10px' }}>
                                {isLoading ? (
                                    <Stack
                                        sx={{ color: 'grey.500' }}
                                        spacing={2}
                                        direction="row"
                                        justifyContent="center"
                                        mt={1}
                                    >
                                        <img
                                            alt="loader"
                                            src={loader}
                                            className="loader"
                                            width={100}
                                            height={100}
                                        />
                                    </Stack>
                                ) : (
                                    <CardContent>
                                        {(endorsementFormData?.type == 'Non-Financial' || endorsementFormData?.type == 'Both') && <>
                                            <CustomerDetails policyDetails={policyDetailsData} />
                                            <DynamicForm policyDetails={policyDetailsData} formNumber={1} />
                                            <DynamicForm policyDetails={policyDetailsData} formNumber={2} />
                                        </>}

                                        {(endorsementFormData?.type == 'Financial' || endorsementFormData?.type == 'Non-Financial' || endorsementFormData?.type == 'Both') && policyDetailsData['policySumInsuredSections'] &&
                                            policyDetailsData['policySumInsuredSections']?.length > 0 ? (
                                            <SumInsured />
                                        ) : null}
                                        {(endorsementFormData?.type == 'Non-Financial' || endorsementFormData?.type == 'Both') && <>
                                            <DynamicForm policyDetails={policyDetailsData} formNumber={3} />

                                            {(policyDetailsData?.['riskDescription'] || policyDetailsData?.['productRiskDescriptionFlag']) && <>
                                                <RiskDescription policyDetails={policyDetailsData} />

                                            </>}
                                            {policyDetailsData?.['policyClauseJSON']?.some(
                                                (item) => item.clauseType === 'coverage'
                                            ) && (
                                                    <CoverageRemark policyDetails={policyDetailsData} />
                                                )}
                                            {policyDetailsData?.['policyClauseJSON']?.some(
                                                (item) => item.clauseType === 'clause'
                                            ) && (
                                                    <ClausesRemark policyDetails={policyDetailsData} />
                                                )}


                                            <HypotheticalDetails policyDetails={policyDetailsData} />
                                          
                                             {policyDetailsData?.['qcData']?.suggestedDeductible?.status !== "NA" && (
                                                  <SuggestedDeductible policyDetails={policyDetailsData} />
                                            )}
                                            {policyDetailsData?.['qcData']?.warranties_exclusions?.status !== "NA" && (
                                                <WarrantiesExclusions policyDetails={policyDetailsData} />
                                            )}
                                           

                                        </>}
                                        {/* {JSON.stringify(endorsementFormData)} */}
                                    </CardContent>
                                )}

                            </Card>
                        </Grid>

                    </Grid>

                </DialogContent>


            </Dialog>
        </div>
    );
};

export default EndorsementUpdateScreenOne;
